import type { InternalDropdownOption } from '~/chords/DropdownTreeSingleSelect/types';
import { updateIsExpandedFalseRecursive } from '~/chords/DropdownTreeSingleSelect/utils/updateIsExpandedFalseRecursive';

interface UpdateOptions {
  option: InternalDropdownOption;
  isExpanded: boolean;
}

export function updateIsExpandedToggle(
  prevOptions: InternalDropdownOption[],
  { option, isExpanded }: UpdateOptions,
) {
  // Deep copy and don't mutate the original "options" object!
  let newOptions = structuredClone(prevOptions);

  if (option.optionIndexPath) {
    let currentOptions = newOptions;
    let parent: InternalDropdownOption | undefined;
    let target: InternalDropdownOption | undefined;

    for (let i = 0; i < option.optionIndexPath.length; i++) {
      const id = option.optionIndexPath[i];

      target = (parent ? parent.children : currentOptions)?.[id];

      if (i < option.optionIndexPath.length - 1) {
        parent = target;
      }
    }

    if (target) {
      target.isExpanded = isExpanded;

      // Recursively collapse all children if the parent is being collapsed.
      if (!isExpanded && target.children) {
        target.children = updateIsExpandedFalseRecursive(target.children);
      }
    }
  }

  return newOptions;
}
